import React from 'react';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import RequestArtifactsPopoverViewModel from '../request-artifacts-popover.viewmodel';
import RequestArtifactsSettings from './request-artifacts-settings';
import RequestArtifactsMeetingsTableLayout from './artifacts-meetings-table-layout';

export interface IArtifactsTabProps {
    intl: IntlShape;
    vm: RequestArtifactsPopoverViewModel;
}

export const ArtifactsTab = observer(({
    vm,
    intl,
}: IArtifactsTabProps) => {

    return (
        <>
            {
                !vm.meetingListEmpty &&
                <>
                    <RequestArtifactsSettings
                        intl={intl}
                        selectedArtifactTypes={vm.selectedArtifactTypes}
                        handleArtifactTypeCheckBox={vm.handleArtifactTypeCheckBox}
                        handleResolutionDropdown={vm.handleResolutionDropdown}
                        resolutionType={vm.resolutionType}
                        isKnovioConnectionExist={vm.isKnovioConnectionExist}
                        handleRecordingTypeDropdown={vm.handleRecordingTypeDropdown}
                        recordingType={vm.artifactRecordingType}
                        isWebinarConnectionExist={vm.isArtifactWebinarConnectionExist}
                    />
                    <hr />
                </>
            }
            <RequestArtifactsMeetingsTableLayout
                intl={intl}
                eventTimeZone={vm.eventSettings.timeZone}
                meetingsList={vm.artifactsMeetingsList}
                isAllMeetingsChecked={vm.isAllMeetingsChecked}
                handleArtifactMeetingCheckBox={vm.handleArtifactMeetingCheckBox}
                selectedMeetingIds={vm.artifactsSelectedMeetingIds}
                selectedTab={vm.selectedTab}
            />
        </>
    );
});